import React from 'react';
import Slider from "@material-ui/core/Slider";
import {pokemonQualityToName} from '../../../../utils';

const QualitySlider = (props) => {
	const marks = [];
	for( let i=0; i<=80; i+= 20 )
		marks.push({value: i, label: pokemonQualityToName(i)});

	return (
		<Slider
			value={props.value}
			onChange={(e, val) => props.setValue(val)}
			valueLabelDisplay="off"
			aria-labelledby="discrete-slider-restrict"
			step={null}
			marks={marks}
			min={0}
			max={80}
		/>
	);
};

export default QualitySlider;